<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Tests",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Tests",
            items: [
               {
                  text: "Tests",
                  active: true,
               },                   
            ],

            
            labs: [
               {
                  id: null,
                  lab_name: "Lab 1"
               },
               {
                  id: null,
                  lab_name: "Lab 2"
               },
               {
                  id: null,
                  lab_name: "Lab 3"
               },
               {
                  id: null,
                  lab_name: "Lab 4"
               },
            ],

            test: {
               id: null,
               name: "",
               description: "",
               type: "",
               lab_id: 0,
               prize: "",

            },
            test_status: {
               id: "",
               status: "",
            },
            test_type: "",
            tests: [],
            test_name: 0,
            all_tests: [],

            lab_id: 0,           
            lab_keyword: '',
            lab_visible: false,
            
            modal_title: "Add Test",
            button_title: "Save",
            pagination: {},
            edit: false,


            type: '',
            keyword: "",
            listing_length: 10,
            token: "",
            errors: {},
            
            loading: false,

            from: "",
            to: "",
            total: "",
            
            delete: false,
            active_page_url: null,
         };
      },
      mounted() {


      },

      created() {
         this.fetchTests();
      },

      methods: {


         fetchTests(page_url = null){

            this.getToken();

            let url = "api/admin/lab/test/index?limit=" + this.listing_length + "&status=" + this.type + "&search=" + this.keyword;
            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

         this.active_page_url = page_url;
            this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               //console.log(responseData);

               // Use responseData.lab and responseData.bookings_count
               this.all_tests = responseData.data;
               this.from = responseData.from;
               this.to = responseData.to;
               this.total = responseData.total;
               this.pagination = responseData.links;



            })
            .catch((error) => {

               if (error.response) {
                  if (error.response.data.message) {

                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  }
                  else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

            })
            .finally(() => (this.loading = false));





         },
         addTest(){


         this.getToken();
         this.loading = true;

         const config = {
            headers: {

               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
         };

         let url = "api/admin/lab/test";
         let formData = new FormData();
         formData.append("name", this.test.name);
         formData.append("description", this.test.description);

         this.$axios
            .post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.$router.push({ name: 'tests' });
               this.clearForm();
               this.hideModal('test-modal');


            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));


            this.fetchTests();






         },




         updateTest(){


            this.getToken();
            this.loading = true;

            const config = {
               headers: {

                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/lab/test/update";
            let formData = new FormData();
            formData.append("id", this.test.id);
            formData.append("name", this.test.name);
            formData.append("description", this.test.description);
            
            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'tests' });
                  this.clearForm();
                  this.hideModal('test-modal');


               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));


               this.fetchTests();






         },


         testUnpublish(all_test){


            this.getToken();

            const config = {
            headers: {

               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
            };

            let url = "api/admin/lab/test/unpublish";
            let formData = new FormData();
            formData.append("id", all_test.id);
            formData.append("status", 1);
            this.$axios
            .post(url, formData, config)
               .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'tests' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
            this.fetchTests();




         },
         activateTest(test) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this test?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.test_status.id = test.id;
                  this.test_status.status = 1;
                  this.updateTestStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateTest(test) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this test?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.test_status.id = test.id;
                  this.test_status.status = 2;
                  this.updateTestStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateTestStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

     
            let url = "api/admin/lab/test/unpublish?id=" + this.test_status.id + "&status=" + this.test_status.status;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchTests(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },

         testDelete(test) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to delete this Test?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                     this.getToken();

                     const config = {
                        headers: {

                           "Accept": "application/json",
                           "Authorization": "Bearer " + this.token,
                        },
                     };

                     let url = "api/admin/test/delete";
                     let formData = new FormData();
                     formData.append("test_id", test.id);

                     this.$axios
                        .post(url, formData, config)
                        .then((response) => {
                           if (response.data.status) {
                              this.$swal("", response.data.message, "success");
                           } else {
                              this.$swal("", response.data.message, "error");
                           }
                           this.fetchTests();
                           this.$router.push({ name: 'tests' });
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         
         closeLabSearch() {
            this.lab_visible = false;        
            this.lab_keyword = '';
         },

         
         setLab() {
            this.lab_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.lab_visible = false;
         },

         
         fetchLabs() {  
            this.lab_visible = true;   
         },
         showModal(modal) {
            this.$refs[modal].show();
         },
         hideModal(modal) {
            this.$refs[modal].hide();
         },
         editTest(all_test) {


            this.edit = true;
            this.test.id = all_test.id;
            this.test.name = all_test.name;
            this.test.description = all_test.description;       
            this.errors = {};
            this.modal_title = "Edit Test";
            this.button_title = "Update";
            this.lab_keyword = '';
            this.lab_visible = false;
            this.labs = [];

            this.showModal("test-modal");
         },
         addTestModal() {



            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;

            var exists = this.tests.some(function(test) {
               return index === test.id;
            });

            if(!exists) {
               this.tests.push({ id: index , title: text });
              }
            this.test = '';

            
          },
          removeTest(index) {
              this.tests.splice(index, 1);
          }, 

         formatDate(dateString) {
            const date = new Date(dateString);

            const day = date.getDate();
            const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
            const year = date.getFullYear();

            const hours = date.getHours();
            const minutes = date.getMinutes();

            return `${day} ${month} ${year}, ${hours}:${minutes < 10 ? '0' : ''}${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;
         },


         clearForm() {
            this.edit = false;
            this.test.id = null;
            this.test.title = "";
            this.test.description = "";
            this.test.name = "";
            this.test.prize = "";
            this.test.lab_id = 0;
            this.lab_keyword = '';
            this.modal_title = "Add Test";
            this.button_title = "Save";
            this.errors = {};
            this.test_name ="";


            this.lab_id = 0;
            this.test_type = "0";
            
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.test-modal variant="primary" class="float-end">Add Test</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change = "fetchTests()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup = "fetchTests()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="type" @change = "fetchTests()">
                              <option value="">All</option>
                              <option value="1">Published</option>
                              <option value="2">Unpublished</option>
                           </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

                        <thead class="table-light">
                           <tr>
                              <th width="10%">Name</th>  
                              <th width="15%">Description</th> 
                              <!-- <th width="10%">Prize</th>  -->
                              <!-- <th width="8%">Lab</th>  -->
                              <th width="10%">Created On</th>
                              <th width="10%">Options</th>
                           </tr>
                        </thead>

                        <tbody v-if="Boolean(all_tests.length)">
                           <tr v-for="(all_test) in all_tests" :key="all_test.id">
                              <td style="max-width: 200px; word-wrap: break-word;"> {{ all_test.name }}</td>
                              <td style="max-width: 200px; word-wrap: break-word;">{{ all_test.description }}</td>
                              <!-- <td>Rs.0.00</td> -->
                              <!-- <td>All</td> -->
                              <td>{{ formatDate(all_test.created_at) }}</td>
                              <td>
                                 <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editTest(all_test)">Edit</b-button>
                                 <b-button v-if="all_test.status==1" variant="danger" class="btn-sm mb-2 me-2" @click="deactivateTest(all_test)">Unpublish</b-button>

                                 <b-button v-else variant="success" class="btn-sm mb-2 me-2" @click="activateTest(all_test)">Publish</b-button>

                                 <b-button variant="danger" class="btn-sm me-2 mb-2" @click="testDelete(all_test)" >Delete</b-button>
                                                
                              </td>
                           </tr>
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No tests found</td>
                           </tr>
                        </tbody>

                  </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(all_tests.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchTests(page.url + '&limit='+ listing_length + '&search=' + keyword + '&status=' + type  )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="test-modal" id="test-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="edit ? updateTest() : addTest()">
                        <div class="row">
                           <b-col md="12" lg="12" class="form-group">
                              <label class="control-label">Name<span class="text-danger">*</span></label>
                              <b-form-input v-model="test.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(test, index) in tests" :key="index">
                                             <p>{{ test.title }}<span @click="removeTest(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                                 </div>

                        <b-col md="12">
                           <b-col md="12" class="form-group">
                           <label class="control-label">Description <span class="text-danger">*</span></label>
                           <textarea v-model="test.description" class="form-control" rows="3" v-bind:class="{ 'is-invalid': Boolean(errors.description) }"></textarea>
                           <div v-for="(val, index) in errors.description" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                           <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                              <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              {{ loading ? 'Saving...' : button_title }}
                           </b-button>
                           <b-button class="" variant="light" @click="hideModal('test-modal')" :disabled="loading">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->
                

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
